import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'

import styles from './Button.scss';

const Button = ( props ) => {
	let classNames = styles.a_button;
  if(props.theme=='dark'){
    classNames = classNames + ' ' + styles.isDark
  }

  if(props.theme=='light'){
    classNames = classNames + ' ' + styles.isLight
  }

  if(props.theme=='primelight'){
    classNames = classNames + ' ' + styles.isPrimeLight
  }

  if(props.margin){
    classNames = classNames + ' ' + styles.margin
  }
  
  if(props.outerMargin){
    classNames = classNames + ' ' + styles.outerMargin
  }

  if(props.nomargin){
    classNames = classNames + ' ' + styles.noMargin
  }
  if(props.nomargin){
    classNames = classNames + ' ' + styles.noMarginMobile
  }

  if(props.multiline){
    classNames = classNames + ' ' + styles.isMultiline
  }

  if(props.href) {
    return (

        <Link className={[classNames, styles.isLink].join(' ')} {...props} style={{
          width: props.width ? props.width : '100%'
      }} to={props.href}>
          {props.value}
        </Link>

    )
  }
  else {
    return (
      <button className={classNames} {...props}
        style={{
                  width: props.width ? props.width : '100%'
              }}>
        {props.value}
      </button>
    )
  }
}

Button.propTypes = {
  value: PropTypes.node.isRequired,
}

export default Button



// WEBPACK FOOTER //
// ./src/components/atoms/Button/index.js